// Estados
export const ESTATUS_ACTIVO = "A";
export const ESTATUS_ACTIVO_LABEL = "Activo";
export const ESTATUS_INACTIVO = "I";
export const ESTATUS_INACTIVO_LABEL = "Inactivo";

// Indicador de Facturación
const INDICADOR_FACTURACION_NO_FACTURABLE = 0;
const INDICADOR_FACTURACION_NO_FACTURABLE_LABEL = "No Facturable";
const INDICADOR_FACTURACION_ITBIS_TASA_1 = 1;
const INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL = "ITBIS 18%";
const INDICADOR_FACTURACION_ITBIS_TASA_2 = 2;
const INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL = "ITBIS 16%";
const INDICADOR_FACTURACION_ITBIS_TASA_3 = 3;
const INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL = "ITBIS 0%";
const INDICADOR_FACTURACION_ITBIS_EXENTO = 4;
const INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL = "Exento";
const INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO = 5;
const INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL = "ITBIS 18% del 10%";

// Indicador de Bien o Servicio
export const ITEM_INDICADOR_BIEN = 1;
export const ITEM_INDICADOR_BIEN_LABEL = "Bien";
export const ITEM_INDICADOR_SERVICIO = 2;
export const ITEM_INDICADOR_SERVICIO_LABEL = "Servicio";

export class Item {
  static get ESTATUS_LIST() {
    return [
      { value: ESTATUS_ACTIVO, label: ESTATUS_ACTIVO_LABEL },
      { value: ESTATUS_INACTIVO, label: ESTATUS_INACTIVO_LABEL },
    ];
  };

  static get INDICADOR_BIEN_O_SERVICIO_LIST() {
    return [
      { value: ITEM_INDICADOR_BIEN, label: ITEM_INDICADOR_BIEN_LABEL },
      { value: ITEM_INDICADOR_SERVICIO, label: ITEM_INDICADOR_SERVICIO_LABEL },
    ];
  };

  static get INDICADOR_FACTURACION_LIST() {
    return [
      { value: INDICADOR_FACTURACION_NO_FACTURABLE, label: INDICADOR_FACTURACION_NO_FACTURABLE_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_TASA_1, label: INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_TASA_2, label: INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_TASA_3, label: INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_EXENTO, label: INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL },
      { value: INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO, label: INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL },
    ];
  };

  static getFacturacionLabel(indicador) {
    switch (indicador) {
      case INDICADOR_FACTURACION_NO_FACTURABLE:
        return INDICADOR_FACTURACION_NO_FACTURABLE_LABEL;
      case INDICADOR_FACTURACION_ITBIS_TASA_1:
        return INDICADOR_FACTURACION_ITBIS_TASA_1_LABEL;
      case INDICADOR_FACTURACION_ITBIS_TASA_2:
        return INDICADOR_FACTURACION_ITBIS_TASA_2_LABEL;
      case INDICADOR_FACTURACION_ITBIS_TASA_3:
        return INDICADOR_FACTURACION_ITBIS_TASA_3_LABEL;
      case INDICADOR_FACTURACION_ITBIS_EXENTO:
        return INDICADOR_FACTURACION_ITBIS_EXENTO_LABEL;
      case INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO:
        return INDICADOR_FACTURACION_ITBIS_18_10_PORCIENTO_LABEL;
    }
  };

  static getEstatusLabel(estatus) {
    switch (estatus) {
      case ESTATUS_ACTIVO:
        return ESTATUS_ACTIVO_LABEL;
      case ESTATUS_INACTIVO:
        return ESTATUS_INACTIVO_LABEL;
    }
  };

  static getIndicadorBienServicioLabel(indicador) {
    switch (indicador) {
      case ITEM_INDICADOR_BIEN:
        return ITEM_INDICADOR_BIEN_LABEL;
      case ITEM_INDICADOR_SERVICIO:
        return ITEM_INDICADOR_SERVICIO_LABEL;
    }
  };

  static get DEFAULT_ESTATUS_VALUE() {
    return ESTATUS_ACTIVO;
  };

  static get PROPIEDADES_EXPORTAR() {
    const propiedades = [
      { value: "IdSec", label: "Id" },
      { value: "Nombre", label: "Nombre" },
      { value: "Descripcion", label: "Descripcion" },
      { value: "EstatusDesc", label: "Estatus" },
      { value: "CrearUsuario", label: "Crear Usuario" },
      { value: "FechaCreacion", label: "Fecha Creación" },
      { value: "ActualizarUsuario", label: "Actualizar Usuario" },
      { value: "FechaActualizacion", label: "Fecha Actualización" },
      { value: "IndicadorBienOServicioDesc", label: "Tipo" },
      { value: "CodigoBarra", label: "Código de Barra" },
      { value: "IndicadorFacturacionDesc", label: "Tipo ITBIS" },
      { value: "PrecioUnitario", label: "Precio" },
      { value: "CategoriaDesc", label: "Categoria" },
    ];
    return propiedades.sort((a, b) => (a.label > b.label ? 1 : -1));
  };
}
